import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OutOfOfficeService {

  constructor(
     private http: HttpClient,
     private session: SessionService,
   ) { 
     environment.API_URL = this.session.GetUserDetails().ApiUrl;
   }
 
   OutOfOfficeRuleInsert(Detail: any)   {
     return this.http.post<any>(environment.API_URL + `OutOfOfficeRuleInsert/Update`,
       this.session.SetClass(Detail)
     ).pipe(map(response => {
       if (response.Error_Code == '11' || response.Error_Code == '02') {
         this.session.End();
       } else {
         return response;
       }
     }));
   }
   OutOfOfficeRuleLoad(Detail: any)   {
    return this.http.post<any>(environment.API_URL + `OutOfOfficeRuleLoad/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  OutOfOfficeAttendanceDetails(Detail: any)   {
    return this.http.post<any>(environment.API_URL + `OutOfOfficeAttendanceDetails/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  OutOfOfficeAttendanceDetailsInsert(Detail: any)   {
    return this.http.post<any>(environment.API_URL + `OutOfOfficeAttendanceDetailsInsert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
